export const LANGUAGE_CONTENT_TYPES = [
	{
        "languageContentTypeId": 5,
        "languageContentTypeName": "Label"
    },
	{
        "languageContentTypeId": 6,
        "languageContentTypeName": "Toastr"
    },
	{
        "languageContentTypeId": 7,
        "languageContentTypeName": "Alert"
    },
	{
        "languageContentTypeId": 8,
        "languageContentTypeName": "Tooltip"
    },
	{
        "languageContentTypeId": 9,
        "languageContentTypeName": "Placeholder"
    },
	{
        "languageContentTypeId": 10,
        "languageContentTypeName": "GridHeader"
    },
	{
        "languageContentTypeId": 11,
        "languageContentTypeName": "ServerMessage"
    },
]